
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

const Container = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid;
    border-color: ${({ isError }) => isError ? " #BB2649": "transparent"};

    label{
        font-size: 16px;
        font-weight: var(--font-weight-md);
        line-height: 12px;
        text-align: left;
        padding: 10px;
        width: ${({labelWidth})=> labelWidth};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.secondaryBgColor};
        border-radius: 5px 0px 0px 5px;
        height: 32px;
    }
    
    input{
        font-size: 16px;
        font-weight: var(--font-weight-md);
        line-height: 12px;
        text-align: left;
        padding: 10px;
        width: ${({inputWidth})=> inputWidth};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 0px 5px 5px 0px;
        height: 32px;
        font-variant-numeric: lining-nums;

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }
`

const InputGroupPhoneNumber = ({handleChange, isRequired=false, labelText, value, name, labelWidth, inputWidth, isSubmitted=false, requiredFields=[]}) => {

    const [isError, setIsError] = useState(false)

    const [isValid, setIsValid] = useState(true)

    const {theme} = useSelector(state => state.layout)
    const regex = /^(\+?90|0)?[0-9]{10}$/;
  
    useEffect(()=> {
      if(isSubmitted && requiredFields && !value){
        if (requiredFields.includes(name)){
          setIsError(true)
        }
        else{
          setIsError(false)
        }
      }
      else{
        setIsError(false)
      }
   
    },[isSubmitted, requiredFields, value])

    useEffect(()=> {
        if(isSubmitted && !isValid){
            setIsError(true)
        }
        else{
            setIsError(false)

        }
    },[isValid, isSubmitted])

    useEffect(() => {
        setIsValid(regex.test(value));
    },[value])

    const handlePhoneInputChange = (e) => {
      const valuee = e.target.value;
      const numericValue = valuee.replace(/\D/g, '');
      if(valuee.length >11){
          return handleChange(value)
      }
      if(valuee[0] !== "0"){
          return handleChange("")
      }
      handleChange(numericValue);
  }

  return (
    <Container isDarkTheme={theme === "dark"} labelWidth={labelWidth} inputWidth={inputWidth} isError={isError}>
      <label htmlFor={name}>{labelText} {isRequired && "*"}</label>
      <input id={name} name={name} type={"tel"} inputMode="numeric" value={value} onChange={handlePhoneInputChange} />
    </Container>
  )
}

export default InputGroupPhoneNumber